/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to create a new document folder.
 * @export
 * @interface CreateDocumentFolderRequest
 */
export interface CreateDocumentFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentFolderRequest
     */
    name: string;
    /**
     * Parent folder ID for nesting. Null for root.
     * @type {number}
     * @memberof CreateDocumentFolderRequest
     */
    parentId?: number | null;
    /**
     * Optional hex color code
     * @type {string}
     * @memberof CreateDocumentFolderRequest
     */
    color?: string | null;
}

/**
 * Check if a given object implements the CreateDocumentFolderRequest interface.
 */
export function instanceOfCreateDocumentFolderRequest(value: object): value is CreateDocumentFolderRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateDocumentFolderRequestFromJSON(json: any): CreateDocumentFolderRequest {
    return CreateDocumentFolderRequestFromJSONTyped(json, false);
}

export function CreateDocumentFolderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentFolderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function CreateDocumentFolderRequestToJSON(json: any): CreateDocumentFolderRequest {
    return CreateDocumentFolderRequestToJSONTyped(json, false);
}

export function CreateDocumentFolderRequestToJSONTyped(value?: CreateDocumentFolderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'parentId': value['parentId'],
        'color': value['color'],
    };
}

